import apiClient from './api';
import cookieService from './cookieService';

export default {
    async login(username, password) {
        const response = await apiClient.post('/auth/login', { username, password });
        if (response.data.access_token) {
            // Set cookie for 3 days
            cookieService.setCookie('token', response.data.access_token, 3);
            // Also set in localStorage as cache
            localStorage.setItem('token', response.data.access_token);
        }
        return response.data;
    },

    async getCurrentUser() {
        const response = await apiClient.get('/auth/me');
        if (response.data) {
            localStorage.setItem('currentUser', JSON.stringify(response.data));
        }
        return response.data;
    },

    async changePassword(newPassword, oldPassword = null) {
        const payload = { new_password: newPassword };
        if (oldPassword) payload.old_password = oldPassword;
        const response = await apiClient.post('/auth/change-password', payload);
        return response.data;
    },

    logout() {
        cookieService.eraseCookie('token');
        localStorage.removeItem('token');
        localStorage.removeItem('currentUser');
    }
};
